import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { categoriesData } from "../../../../helpers/Arrays";
import DownloadIcon from "@mui/icons-material/Download";
import InfoIcon from "@mui/icons-material/Info";
import { Images } from "../../../../helpers/Images";
// import Images from "../../../../helpers/Images";

const RoboBoomTemplate = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const categories = [
    {
      title: "Construction LEGO",
      description:
        "Build and program LEGO robots to complete construction challenges",
      details: [
        "Age: 6-10",
        "Team size: 3-5 people",
        "Hardware: LEGO WEDO 2.0",
        "Construction Time: 40 minutes",
        "Presentation Time: 5 minutes",
      ],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1QxVdc19WyrYd3IgARSFvYdxdzg4EEJMm",
    },
    {
      title: "Line Sprint",
      description:
        "Race your robot along a line following course with speed and precision",
      details: [
        "Age: 6-10",
        "Team size: 3-5 people",
        "Hardware: Any type of robot",
        "Maximum size: 20 x 20 x 20 cm",
        "Weight limit: 1.5kg",
      ],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1HgYKkyGytHmpq3V_DIKcbxhz-OXbzVHe",
    },
    {
      title: "Line Sprint LEGO",
      description: "Line following competition using LEGO-based robots",
      details: [
        "Age: 6-10",
        "Team size: 3-5 people",
        "Hardware: LEGO WEDO 2.0 / Spike Essential",
        "Maximum size: 20 x 20 x 20 cm",
        "Weight limit: 1.5kg",
      ],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1MmocAJNT7gyjIYHHUgrj5afYus4NnlDt",
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${Images.roboBoom})`,
          backgroundSize: "cover",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
          color: "white",
          py: 8,
          mb: 6,
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: "700",
              textAlign: "center",
              mb: 2,
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)"
            }}
          >
            RoboBoom Challenge
          </Typography>
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              maxWidth: "800px",
              mx: "auto",
              opacity: 0.9,
              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)"
            }}
          >
            Explore our exciting robotics competitions designed for young
            innovators
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Grid container spacing={4}>
          {categories.map((category, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: theme.shadows[8],
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "600",
                      mb: 2,
                      color: theme.palette.primary.main,
                    }}
                  >
                    {category.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{ mb: 3, color: "text.secondary" }}
                  >
                    {category.description}
                  </Typography>

                  <Box sx={{ mb: 3 }}>
                    {category.details.map((detail, idx) => (
                      <Typography
                        key={idx}
                        variant="body2"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 1,
                          "&:before": {
                            content: '"•"',
                            mr: 1,
                            color: theme.palette.primary.main,
                          },
                        }}
                      >
                        {detail}
                      </Typography>
                    ))}
                  </Box>

                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    <Button
                      variant="contained"
                      startIcon={<DownloadIcon />}
                      component="a"
                      href={category.pdfLink}
                      download
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        "&:hover": {
                          backgroundColor: theme.palette.primary.dark,
                        },
                      }}
                    >
                      Rules PDF
                    </Button>
                    <Button
                      variant="outlined"
                      //   startIcon={<InfoIcon />}
                      onClick={() => navigate("/firststage")}
                      sx={{
                        borderColor: theme.palette.primary.main,
                        color: theme.palette.primary.main,
                        "&:hover": {
                          borderColor: theme.palette.primary.dark,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      Register Now
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Box
        sx={{
          width: "100%",
          backgroundColor: "primary.main",
        }}
      >
        <Box
          sx={{
            width: "100%",
            padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
            maxWidth: "1500px",
            margin: "auto",
          }}
        >
          <Typography
            variant={"h2"}
            sx={{
              textAlign: "center",
              fontSize: { xs: "40px" },
              fontWeight: "500",
              color: "secondary.main",
            }}
          >
            Our All Categories
          </Typography>
          <Box
            sx={{
              height: "3px",
              maxWidth: { xs: "100px", md: "150px" },
              width: "100%",
              backgroundColor: "secondary.main",
              margin: "10px auto 0 auto",
            }}
          />
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "50px", justifyContent: "center" }}
          >
            {categoriesData
              ?.filter((category) => category.title !== "RoboBoom")
              ?.map((item) => (
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${item.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      width: "100%",
                      minHeight: { xs: "200px", sm: "250px" },
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      variant={"h3"}
                      sx={{
                        textAlign: "center",
                        fontSize: "35px",
                        fontWeight: "500",
                        color: "secondary.main",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        height: "3px",
                        maxWidth: "90px",
                        width: "100%",
                        backgroundColor: "secondary.main",
                        margin: "5px auto 5px auto",
                      }}
                    />
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "primary.main",
                          width: "fit-content",
                          margin: { xs: "5px 0 20px 0", sm: "10px 0 40px 0" },
                        }}
                        onClick={() => navigate(item.link)}
                      >
                        view
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default RoboBoomTemplate;
